﻿import {FormattableString, isNullOrEmpty, translation} from "@2d-front-monorepo/core";
import React, {JSX, ReactNode, useMemo} from "react";
import {useControlId} from "../helpers/useControlId";
import Icon from "../Icon";

export type MessageType = "error" | "warning" | "information" | "success" | "";

export interface MessageProps {
	title: FormattableString;
	detail?: FormattableString;
	footer?: FormattableString;
	items?: FormattableString[];
	type?: MessageType;
	className?: string;
	ref?: React.Ref<HTMLDivElement>;
	children?: ReactNode;
}

export default function Message({title, detail, items, footer, type, className, ref, children}: MessageProps): JSX.Element {
	const controlId = useControlId();
	const ariaLive = type === "error" || type === "warning" ? "assertive" : "polite";
	const klass = useMemo(() => "form-message" + (isNullOrEmpty(type) ? "" : ` form-message--${type}`) + (isNullOrEmpty(className) ? "" : ` ${className}`), [type, className]);

	return <div className={klass} role="alert" aria-labelledby={controlId} aria-live={ariaLive} ref={ref}>
		<div className="form-message__icon" data-icon={"message-" + type}></div>
		<div className="form-message__contents">
			<h6 id={controlId}>{translation(title)}</h6>
			{detail ? <p>{translation(detail)}</p> : null}
			{items != null && items.length > 0 ?
				<ul>
					{items.map((item) => <li key={item.text}><Icon
						icon={"message-item-entry"}/> {translation(item)}</li>)}
				</ul>
				: null}
			{children}
			{footer ? <div><small>{translation(footer)}</small></div> : null}
		</div>
	</div>;
}
